import React from 'react';

const DownloadTAInputs = ({ fundData }) => {
  const handleDownloadCsv = () => {
    const fundNames = Object.keys(fundData);

    // 1) Gather parameter keys from all funds' ta_inputs, skipping the undesired ones.
    const EXCLUDE_KEYS = new Set(['fundName', 'pacingStartDate', 'commitmentLocal']);
    const paramSet = new Set();

    fundNames.forEach((fName) => {
      const { ta_inputs = {} } = fundData[fName];
      Object.keys(ta_inputs).forEach((key) => {
        if (!EXCLUDE_KEYS.has(key)) {
          paramSet.add(key);
        }
      });
    });

    const paramKeys = Array.from(paramSet);

    // 2) Build the CSV rows in the desired transposed format:
    //    - First row: ['fundName', 'paramKey1', 'paramKey2', ...]
    //    - Next rows: [Fund A, valueParamKey1, valueParamKey2, ...]
    const rows = [];
    rows.push(['fundName', ...paramKeys]);

    // For each fund, fill out the row
    fundNames.forEach((fName) => {
      const { ta_inputs = {} } = fundData[fName];
      const row = [fName]; // first cell = fundName

      // subsequent cells = each paramKey's value
      paramKeys.forEach((key) => {
        row.push(ta_inputs[key] ?? '');
      });
      rows.push(row);
    });

    // 3) Convert array-of-arrays to a CSV string
    const csvString = rows
      .map((row) => row.join(',')) // Join each row with commas
      .join('\n');                // Join rows with newlines

    // 4) Create a Blob for the CSV and trigger a download
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'ta_inputs.csv';
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={handleDownloadCsv}
      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
    >
      Download Inputs
    </button>
  );
};

export default DownloadTAInputs;